import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "../../Services/Context/AuthContext";
import { useDarkMode } from "../../Services/Context/DarkModeContext";
import { TermsContent, PrivacyContent } from "./AuthModal";
import "./AuthModal.css";

type View = "gate" | "terms" | "privacy";

const TosGate = () => {
  const { acceptTos } = useAuth();
  const { dark } = useDarkMode();
  const [view, setView] = useState<View>("gate");
  const [accepted, setAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAccept = async () => {
    if (!accepted) return;
    setIsLoading(true);
    await acceptTos();
    // AuthContext updates user metadata; tosAccepted re-derives automatically
  };

  const isLegalView = view === "terms" || view === "privacy";

  return (
    <motion.div
      className="AuthModal-backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ zIndex: 300 }}
    >
      <motion.div
        className={`AuthModal-card ${dark ? "AuthModal-card--dark" : ""} ${isLegalView ? "AuthModal-card--legal" : ""}`}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      >
        {isLegalView ? (
          <>
            <div className="AuthModal-legal-header">
              <button
                className="AuthModal-back-btn"
                onClick={() => setView("gate")}
                aria-label="Back"
              >
                ← Back
              </button>
              <h2 className="AuthModal-legal-title">
                {view === "terms" ? "Terms of Service" : "Privacy Policy"}
              </h2>
            </div>
            <div className="AuthModal-legal-body">
              <AnimatePresence mode="wait">
                {view === "terms"
                  ? <TermsContent key="terms" />
                  : <PrivacyContent key="privacy" />}
              </AnimatePresence>
            </div>
          </>
        ) : (
          <>
            <div className="AuthModal-sigil">✦</div>
            <h2 className="AuthModal-title">One last step</h2>
            <p className="AuthModal-subtitle">
              Please agree to our terms before continuing
            </p>

            <label className="AuthModal-tos-check">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                className="AuthModal-checkbox"
              />
              <span className="AuthModal-tos-text">
                I agree to the{" "}
                <button
                  type="button"
                  className="AuthModal-tos-link"
                  onClick={() => setView("terms")}
                >
                  Terms of Service
                </button>
                {" "}and{" "}
                <button
                  type="button"
                  className="AuthModal-tos-link"
                  onClick={() => setView("privacy")}
                >
                  Privacy Policy
                </button>
              </span>
            </label>

            <button
              className="AuthModal-magic-btn"
              style={{ width: "100%", marginTop: 4 }}
              disabled={!accepted || isLoading}
              onClick={handleAccept}
            >
              {isLoading ? "Saving…" : "Accept & Continue"}
            </button>
          </>
        )}
      </motion.div>
    </motion.div>
  );
};

export default TosGate;
